import ProfileImageDao from '../dao/profile-image.dao';
import type { Environment } from '../interfaces/environment';

export abstract class ProfileImageService {
  static fetchImage(
    env: Environment,
    size: number,
    personId?: number
  ): Promise<string> {
    if (!personId) {
      throw new Error('Missing personId');
    }

    return ProfileImageDao.fetchImage(env, size, personId);
  }
}
